module.exports = __webpack_public_path__ + "static/media/api.0978b367.md";